import { Modal } from 'antd'
import Button from 'components/Button'
import Flex from 'components/Flex'
import SelectCollegesDrawer from 'modules/Roles/NewRoleCreation/Partials/SelectCollegesDrawer'
import { MainWrapper } from 'modules/Roles/NewRoleCreation/Partials/Style/style'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import styled from 'styled-components'
import RoleEntryForm from './Partials/RoleCreateForm'
import { useDataFetch } from '../../../hooks/useDataFetch'
import { initialRoleValues, getTitle } from '../../../helpers/formHelpers'
import { setSingleRoleData } from 'modules/Roles/actions'
const CorporateDetails = React.lazy(() => import('./Partials/RoleCreateForm/Partials/CorporateDetails'))
const JobDetails = React.lazy(() => import('./Partials/RoleCreateForm/Partials/JobDetails'))
const CtcJobLocation = React.lazy(() => import('./Partials/RoleCreateForm/Partials/CtcJobLocation'))
const EligibilityCriteria = React.lazy(() =>
  import('./Partials/RoleCreateForm/Partials/EligibiltyCriteria')
)
const QualifyQuestions = React.lazy(() => import('./Partials/RoleCreateForm/Partials/QualifyQuestions'))
const ApplicationForm = React.lazy(() => import('./Partials/RoleCreateForm/Partials/ApplicationForm'))
const EvaluationProcess = React.lazy(() =>
  import('./Partials/RoleCreateForm/Partials/EvaluationProcess')
)
const Preview = React.lazy(() => import('./Partials/RoleCreateForm/Partials/Preview'))
import { useDispatch } from 'react-redux'

const isITIOrDiplomaRole = (roleData, elgibilty, selectedCourses) => {
  const pd = (roleData?.priorityDegree || '').toUpperCase()
  if (pd.includes('ITI') || pd.includes('DIPLOMA') || pd.includes('UG_DIPLOMA')) return true

  const criteria = roleData?.eligibilityCriteria || elgibilty?.eligibilityCriteria
  if (Array.isArray(criteria)) {
    for (const group of criteria) {
      const items = Array.isArray(group) ? group : [group]
      for (const item of items) {
        const dt = (item?.degreeType || '').toUpperCase()
        if (dt === 'ITI' || dt === 'DIPLOMA' || dt === 'UG_DIPLOMA') return true

        // Check if any selected degree has DIPLOMA as its type
        if (item?.isSelected && (item?.type === 'DIPLOMA' || item?.degreeType === 'DIPLOMA')) {
          return true
        }

        // Check streams and specializations for DIPLOMA type
        if (item?.streams && Array.isArray(item.streams)) {
          for (const stream of item.streams) {
            if (stream?.isSelected && stream?.degreeType === 'DIPLOMA') {
              return true
            }
          }
        }
      }
    }
  }

  // Check selectedCourses for any DIPLOMA or ITI type selections
  // Only returns true if actual items are selected (not just tab clicked)
  if (Array.isArray(selectedCourses)) {
    for (const criteriaGroup of selectedCourses) {
      if (Array.isArray(criteriaGroup) && criteriaGroup.length > 0) {
        for (const selected of criteriaGroup) {
          const dt = (selected?.degreeType || selected?.type || '').toUpperCase()
          if (dt === 'DIPLOMA' || dt === 'UG_DIPLOMA' || dt === 'ITI') {
            return true
          }
        }
      }
    }
  }

  return false
}

// Show Application Form step for: ITI/Diploma roles OR Off Campus/Lateral roles
const shouldShowApplicationForm = (roleData, elgibilty, selectedCourses, formValues) => {
  const isForAll = formValues?.jobDetails?.isForAll ?? roleData?.isForAll
  if (isForAll === true) return true
  return isITIOrDiplomaRole(roleData, elgibilty, selectedCourses)
}

const buildStepFlow = (isApplicationForm, jobCategory) => [
  {
    key: 1,
    activeKey: 0,
    title: 'Corporate Details',
    completed: false,
    component: CorporateDetails,
  },
  {
    key: 2,
    activeKey: 1,
    title: 'Job Details',
    completed: false,
    component: JobDetails,
  },
  {
    key: 3,
    activeKey: 2,
    title: jobCategory ? getTitle(jobCategory) : 'CTC & Job location',
    completed: false,
    component: CtcJobLocation,
  },
  {
    key: 4,
    activeKey: 3,
    title: 'Eligibility Criteria',
    completed: false,
    component: EligibilityCriteria,
  },
  {
    key: 5,
    activeKey: 4,
    title: isApplicationForm ? 'Application Form' : 'Qualifying Questions',
    completed: false,
    component: isApplicationForm ? ApplicationForm : QualifyQuestions,
  },
  {
    key: 6,
    activeKey: 5,
    title: 'Evaluation Process',
    completed: false,
    component: EvaluationProcess,
  },
  {
    key: 7,
    activeKey: 6,
    title: 'Preview',
    completed: false,
    component: Preview,
  },
]

export const FlexWrapRole = styled(Flex)`
  width: ${props => (props.width ? props.width : '100%')};
  gap: ${props => (props.gap ? props.gap : '0')};
`

const NewRoleCreation = ({
  newCorporateJobRoles,
  previewRoleData,
  publishCorporateJobRole,
  setCurrentJobId,
  currentJobId,
  updateCorporateJobRoles,
  singleRoleData,
  isEditingRole,
  getListOfDegree,
  listOfDegree,
  getListOfSkills,
  getDesignationsList,
  designationsList,
  listOfCities,
  getCities,
  isEditRoleOnView,
  corporateData,
  getInstitutesList,
  institutesList,
  getInstitutesLocationList,
  getSingleRoleData,
  getSpecialisationList,
  specialisationList,
  getJobRoleCampusList,
  getListOfCountries,
  permissions,
  getNotificationCatalogues,
  createQuestionarie,
  getAllQuestionarieList,
  allQuestionarieList,
  deleteQuestion,
  editQuestionarie,
  getSingleQuestionarie,
  singleQuestion,
  setSingleQuestionarie,
  getAllQuestionBankList,
  allQuestionBankList,
  createQuestionarieBank,
  corporateId,
  institutesLocationList,
  draftData,
  getElasticSearchDegreeData,
  elasticSearchData,
  locationList,
  getLocations,
  getUserList,
  listOfSkills,
  postCorporateJobRole,
  updateJobRole,
  getYearOfPassing,
  yearOfPassing,
  getEligibilityCriteriaQualification,
  courseData,
  getCourses,
  createGroup,
  updateGroup,
  deleteGroup,
  oneGroupDetail,
  removeInstituteFromGroup,
  getMatchedInstituteList,
  instituteGroupList,
  createDraftSelectInstitute,
  getSelectedInstitutes,
  updateCorporateInstituteDetails,
  createCorporateInstituteDetails,
  dublicateGroup,
  getMatchedInstituteListFilter,
  groupInstituteListFilter,
  getSelectedInstitutesFilter,
  getPreviewData,
  getMapMetrics,
  publishRole,
  deleteSelectedDraftInstitute,
  roleDetails,
  getStepper,
  corporateDetails
}) => {
  console.log(singleRoleData,'singleRoleData')
  const { jobId } = useParams()

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [collegeDrawer, setCollegeDrawer] = useState(false)
  const [republishPopup, setRepublishPopup] = useState(false)
  const [selectedInstituteData, setSelectedInstituteData] = useState([])
  const [roleData, setRoleData] = useState({})
  const [updateTrigger, setUpdateTrigger] = useState([])
  const [degreeStreamMapIds, setDegreeStreamMapIds] = useState([])
  const [instituteError, setInstituteError] = useState('')
  const params = useLocation()
  const searchParams = new URLSearchParams(params.search)
  const csValue = searchParams.get('CS') ? Number(searchParams.get('CS')) : 0
  const [currentStep, setCurrentStep] = useState(csValue)
  const [currentElgibilty, setCurrentElgibilty] = useState({})
  const [selectedCourses, setSelectedCourses] = useState([])
  const [formIsForAll, setFormIsForAll] = useState(false)
  const [cachedJobCategory, setCachedJobCategory] = useState(singleRoleData?.jobCategory)
  
  const [stepData, setStepData] = useState(() => {
    if (!jobId) return buildStepFlow(false, null)

    // For edit mode, initialize with step completion based on roleData
    const editStepFlow = buildStepFlow(false, cachedJobCategory)
    return editStepFlow.map((step, idx) => {
      const stepKeys = Object.keys(initialRoleValues || {})
      const key = stepKeys[idx]
      const currentState = Number(singleRoleData?.currentState) || 0

      let completed = false

      if (singleRoleData?.status === 1) {
        completed = true
      } else if (
        key === 'qualifyQuestions' &&
        singleRoleData?.questionBankRoleMap?.length > 0
      ) {
        completed = true
      } else {
        completed = idx <= currentState
      }

      return { ...step, completed }
    })
  })
  // Rebuild step flow when role data indicates ITI/Diploma
  // Rebuild step flow when role data indicates ITI/Diploma or Off Campus
  useEffect(() => {
    const formValues = { jobDetails: { isForAll: formIsForAll } }
    const shouldUseAppForm = shouldShowApplicationForm(singleRoleData, currentElgibilty, selectedCourses, formValues)
    const newSteps = buildStepFlow(shouldUseAppForm, cachedJobCategory)
    setStepData(prev =>
      newSteps.map((step, idx) => ({
        ...step,
        completed: prev[idx]?.completed || false,
      }))
    )
  }, [singleRoleData?.priorityDegree, singleRoleData?.eligibilityCriteria, currentElgibilty, selectedCourses, cachedJobCategory, formIsForAll])

  // Update cached job category when singleRoleData loads
  useEffect(() => {
    if (singleRoleData?.jobCategory && singleRoleData?.jobCategory !== cachedJobCategory) {
      setCachedJobCategory(singleRoleData.jobCategory)
    }
  }, [singleRoleData?.jobCategory, cachedJobCategory])

  const [viewGroupCollege, setviewGroupCollege] = useState(false)
  const fetchRoleDetails = async roleId => {
    const roleDetails = await getPreviewData(roleId)

    setRoleData(roleDetails)
    setDegreeStreamMapIds(roleDetails?.degreeStreamMapIds)
    setUpdateTrigger(false)
  }
  // Clear singleRoleData when creating a new role (no jobId)
  useEffect(() => {
    if (!jobId) {
      dispatch(setSingleRoleData({}))
      setCurrentJobId('')
      setRoleData({})
      setCurrentStep(0)
      setStepData(buildStepFlow(false, null))
    }
  }, [jobId])

  useEffect(() => {
    if (jobId) {
      fetchRoleDetails(jobId)
    }
  }, [updateTrigger])
  useEffect(() => {
    if (jobId) {
      let roleData = getSingleRoleData(1, jobId)
      console.log(roleData,'roleDataAPI')
    }
  }, [jobId])

  const [draftModalVisible, setDraftModalVisible] = useState(false)

  return (
    <>
      <MainWrapper column>
        <RoleEntryForm
          updateTrigger={updateTrigger}
          setUpdateTrigger={setUpdateTrigger}
          allQuestionarieList={allQuestionarieList}
          getAllQuestionarieList={getAllQuestionarieList}
          getUserList={getUserList}
          createQuestionarie={createQuestionarie}
          updateJobRole={updateJobRole}
          listOfDegree={listOfDegree}
          corporateData={corporateData}
          listOfSkills={listOfSkills}
          postCorporateJobRole={postCorporateJobRole}
          roleData={jobId ? singleRoleData : {}}
          getSingleRoleData={getSingleRoleData}
          getYearOfPassing={getYearOfPassing}
          yearOfPassing={yearOfPassing}
          getEligibilityCriteriaQualification={
            getEligibilityCriteriaQualification
          }
          getAllQuestionBankList={getAllQuestionBankList}
          courseList={courseData}
          getCourses={getCourses}
          getSingleQuestionarie={getSingleQuestionarie}
          editQuestionarie={editQuestionarie}
          deleteQuestion={deleteQuestion}
          createQuestionarieBank={createQuestionarieBank}
          getListOfSkills={getListOfSkills}
          getPreviewData={getPreviewData}
          setCollegeDrawer={setCollegeDrawer}
          setRepublishPopup={setRepublishPopup}
          roleDetails={roleDetails}
          jobId={jobId}
          previewData={roleData}
          fetchRoleDetails={fetchRoleDetails}
          getStepper={getStepper}
          stepData={stepData}
          setStepData={setStepData}
          currentStep={currentStep}
          corporateDetails={corporateDetails}
          setCurrentStep={setCurrentStep}
          onFormValuesChange={setCurrentElgibilty}
          onSelectedCoursesChange={setSelectedCourses}
          onIsForAllChange={setFormIsForAll}
          publishRole={publishRole}
        />
      </MainWrapper>

      <SelectCollegesDrawer
        jobId={jobId}
        publishRole={publishRole}
        collegeDrawer={collegeDrawer}
        setCollegeDrawer={setCollegeDrawer}
        selectedInstituteData={selectedInstituteData}
        setSelectedInstituteData={setSelectedInstituteData}
        instituteError={instituteError}
        setInstiteError={setInstituteError}
        roleData={roleData}
        degreeStreamMapIds={degreeStreamMapIds}
        previewRoleData={previewRoleData}
        getInstitutesList={getInstitutesList}
        getInstitutesLocationList={getInstitutesLocationList}
        institutesList={institutesList}
        getJobRoleCampusList={getJobRoleCampusList}
        isEditRoleOnView={isEditRoleOnView}
        institutesLocationList={institutesLocationList}
        createGroup={createGroup}
        updateGroup={updateGroup}
        deleteGroup={deleteGroup}
        oneGroupDetail={oneGroupDetail}
        removeInstituteFromGroup={removeInstituteFromGroup}
        viewGroupCollege={viewGroupCollege}
        setviewGroupCollege={setviewGroupCollege}
        getMatchedInstituteList={getMatchedInstituteList}
        instituteGroupList={instituteGroupList}
        createDraftSelectInstitute={createDraftSelectInstitute}
        getSelectedInstitutes={getSelectedInstitutes}
        updateCorporateInstituteDetails={updateCorporateInstituteDetails}
        createCorporateInstituteDetails={createCorporateInstituteDetails}
        dublicateGroup={dublicateGroup}
        getMatchedInstituteListFilter={getMatchedInstituteListFilter}
        groupInstituteListFilter={groupInstituteListFilter}
        getSelectedInstitutesFilter={getSelectedInstitutesFilter}
        getMapMetrics={getMapMetrics}
        deleteSelectedDraftInstitute={deleteSelectedDraftInstitute}
      />
      <Modal
        open={draftModalVisible}
        centered // This prop centers the modal vertically and horizontally
        footer={null} // Hide the default footer
        maskClosable={false} // Prevent closing the modal when clicking outside
        closable={false} // Hide the close button
        bodyStyle={{
          borderRadius: '20px',
          padding: '32px 20px 32px 20px',
          textAlign: 'center',
        }}
      >
        <Flex column>
          <div
            style={{
              fontWeight: 600,
              lineHeight: '25px',
              fontSize: '16px',
              color: '#4D566E',
              marginBottom: '40px',
            }}
          >
            Do you want to save the changes ?
          </div>
          <br />

          <FlexWrapRole gap="20px" center>
            <Button.Primary
              text="Save"
              onClick={() => {
                if (draftData?.status == 0 && !isPublish) {
                  setSave(true)
                  setSaveAsDraft(true)
                  setDraftModalVisible(false)
                } else {
                  setSaveAsDraft(true)
                  setSave(true)
                }
              }}
            />
            <Button.Secondary
              text="Don't Save"
              onClick={() => navigate('/rolePage')}
            />
            <Button.Secondary
              text={'Back to Edit'}
              onClick={() => setDraftModalVisible(false)}
            />
          </FlexWrapRole>
        </Flex>
      </Modal>
    </>
  )
}

export default NewRoleCreation
